import Staging from './staging.config';
import Production from './production.config';
export var envConfigs = {
  production: Production,
  staging: Staging
};